/**
 * The only colours a machine can be given. A fixed list rather than free text,
 * so "Grey", "gray" and "Gray " never become three colours. To add one, add it
 * here AND to EQUIPMENT_COLOURS in HHNodeServer/src/routes/equipment.js — the
 * server refuses anything not on its list. The hex is only for the swatch.
 */
export const EQUIPMENT_COLOURS: { name: string; hex: string }[] = [
  { name: 'White',  hex: '#ffffff' },
  { name: 'Black',  hex: '#1f2937' },
  { name: 'Silver', hex: '#c0c4c9' },
  { name: 'Grey',   hex: '#6b7280' },
  { name: 'Red',    hex: '#dc2626' },
  { name: 'Blue',   hex: '#2563eb' },
  { name: 'Green',  hex: '#16a34a' },
  { name: 'Yellow', hex: '#facc15' },
  { name: 'Orange', hex: '#f97316' },
  { name: 'Brown',  hex: '#92400e' },
];

/** The swatch for a stored colour, or null for anything not on the list. */
export function colourSwatch(colour: string | null | undefined): string | null {
  return EQUIPMENT_COLOURS.find(o => o.name === colour)?.hex ?? null;
}
